// Initial state and status props
// are stored here to avoid circular dependencies.
// When commentsReducer.js no longer has specific reducers
// (and just collates them all together),
// they could be moved back there.

export const INITIAL_STATE = {
  comments: [],
  error: false,
  errorType: null,
  isFetching: false,
  success: false,
  isPosting: false,
  isLastPage: true,
  isLoadingMore: false,
  loadMoreError: false
};

export const INITIAL_STATUS_PROPS = {
  childLoading: {
    loading: false,
    error: false,
    errorType: null,
    isLoadingMore: false,
    loadMoreError: false,
    isLastPage: true,
    totalCount: 0
  },
  editing: {
    isEditing: false,
    error: false,
    submitting: false
  },
  translation: {
    isTranslated: false,
    loading: false,
    error: false
  }
};
